import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";
export const get_all_employee_master_pto = async (org_id: any) => {
  const path = `/orgs/${org_id}/time_off`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
